<template>
  <v-card class="card-border">
    <v-card-text>
      <v-form ref="form">
        <v-row align="center">
          <v-col cols="12" sm="12" md="3">
            <SelectTipo
              :multiple="false"
              @onChanged="tipo = $event; disableSelectfabricante($event)"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <SelectFabricante
              :multiple="false"
              :disabled="disableSelectFabricante"
              :validate="validateFabricante"
              :clearSelect="clearSelectFabricante"
              @onChanged="fabricante = $event"
            />
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <SelectEmpresa
              :multiple="true"
              :disabled="disableSelectEmpresa"
              :validate="validateEmpresa"
              @onChanged="empresas = $event"
            />
          </v-col>
          <v-col cols="12" sm="12" md="2">
            <v-btn
              outlined
              color="blue darken-2"
              rounded
              dark
              depressed
              small
              @click="sincronizar()"
            >
              <v-icon left>mdi-autorenew</v-icon>Sincronizar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Veiculo from "@/services/veiculo";
import ProdutoForca from "@/services/produtoForca";
import Consorcio from "@/services/consorcio";
import Financiamento from "@/services/financiamento";
import FinanciamentoProdutoForca from "@/services/financiamentoProdutoForca";
import Empresa from "@/services/empresa";
import Parametro from "@/services/parametro";

export default {
  name: "Filtro",

  components: {
    SelectFabricante: () => import("@/components/select/SelectFabricante"),
    SelectTipo: () => import("./SelectTipo"),
    SelectEmpresa: () => import("@/components/select/SelectEmpresa")
  },

  data() {
    return {
      fabricante: null,
      tipo: null,
      empresas: null,
      disableSelectFabricante: false,
      validateFabricante: false,
      clearSelectFabricante: false,
      disableSelectEmpresa: false,
      validateEmpresa: false,
      serviceVeiculo: new Veiculo(),
      serviceProdutoForca: new ProdutoForca(),
      serviceConsorcio: new Consorcio(),
      serviceFinanciamento: new Financiamento(),
      serviceFinanciamentoProdutoForca: new FinanciamentoProdutoForca(),
      serviceEmpresa: new Empresa(),
      serviceParametro: new Parametro()
    };
  },

  methods: {
    async sincronizar() {
      if (this.$refs.form.validate()) {
        try {
          if (this.tipo == "Veiculos") {
            await this.sincVeiculos();
          } else if (this.tipo == "Produto") {
            await this.sincProdutoForca();
          } else if (this.tipo == "Consorcio") {
            await this.sincConsorcio();
          } else if (this.tipo == "Financiamento") {
            await this.sincFinanciamento();
          } else if (this.tipo == "Financiamento Produto Forca") {
            await this.sincFinanciamentoProdutoForca();
          } else if (this.tipo == "Empresas") {
            await this.sincEmpresa();
          } else {
            await this.sincParametro();
          }
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao efetuar a sincronização");
          return Promise.reject(error);
        }
      }
    },

    async sincVeiculos() {
      try {
        await this.serviceVeiculo.criaSincronizacao(this.fabricante);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao efetuar a sincronização");
        return Promise.reject(error);
      }
    },

    async sincProdutoForca() {
      try {
        console.log("entrou");
        await this.serviceProdutoForca.criaSincronizacao(this.fabricante);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao efetuar a sincronização");
        return Promise.reject(error);
      }
    },

    async sincConsorcio() {
      try {
        await this.serviceConsorcio.criaSincronizacao(this.fabricante);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao efetuar a sincronização");
        return Promise.reject(error);
      }
    },

    async sincFinanciamento() {
      try {
        await this.serviceFinanciamento.criaSincronizacao(this.fabricante);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao efetuar a sincronização");
        return Promise.reject(error);
      }
    },

    async sincFinanciamentoProdutoForca() {
      try {
        await this.serviceFinanciamentoProdutoForca.criaSincronizacao(this.fabricante);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao efetuar a sincronização");
        return Promise.reject(error);
      }
    },

    async sincEmpresa() {
      try {
        await this.serviceEmpresa.criaSincronizacao(this.empresas);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao efetuar a sincronização");
        return Promise.reject(error);
      }
    },

    async sincParametro() {
      try {
        await this.serviceParametro.criaSincronizacao(this.tipo, this.empresas);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao efetuar a sincronização");
        return Promise.reject(error);
      }
    },

    disableSelectfabricante(tipo) {
      if (
        tipo == "Empresas" ||
        tipo == "Parametro Financiamento" ||
        tipo == "Parametro Consorcio" ||
        tipo == "Parametro Comissão" ||
        tipo == "Parametro Leads"
      ) {
        this.disableSelectFabricante = true;
        this.validateFabricante = false;
        this.clearSelectFabricante = true;
        this.disableSelectEmpresa = false;
      } else {
        this.disableSelectEmpresa = true;
        this.validateEmpresa = false;
        this.clearSelectFabricante = false;
        this.disableSelectFabricante = false;
      }
    }
  }
};
</script>
